import './styles.scss'
import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import { smartChat } from 'api'
import { getStaticImage } from 'utils/statics'
import { Button } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import ModalDelete from 'components/ModalDelete'
import PhoneViewer from 'components/PhoneViewer'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { lang } from 'utils/helpers'

const Message = (props) => {
  const { getMessageGroup, groupsInfo, message: messageExt, company } = props
  const [submitting, setSubmitting] = React.useState(false)
  const [mode, setMode] = React.useState('list')
  const [textPreview, setTextPreview] = React.useState({})
  const [message, setMessage] = React.useState(messageExt)
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const toggleDelete = () => setIsOpenDelete(!isOpenDelete)
  const [currentChannelPreview, setCurrentChannelPreview] = React.useState(undefined)
  const [isOpenPhonePreviewModal, setIsOpenPhonePreviewModal] = React.useState(false)
  const [messageError, setMessageError] = React.useState(null)

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) setMessageError(null)

    return () => isSubscribed = false
  }, [message])

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (messageExt._id === '0') setMode('add')

      setMessage(messageExt)
    }

    return () => isSubscribed = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageExt])

  const togglePhonePreviewModal = () => setIsOpenPhonePreviewModal(!isOpenPhonePreviewModal)

  const toogleEdit = () => {
    setMode('edit')
  }

  const close = () => {
    if (mode === 'add')
      getMessageGroup({ message: message, mode: 'remove' })
    else
      setMessage(messageExt)
    setMode('list')
  }

  const saveMessage = () => {
    if (!message.name) {
      setMessageError(I18n.t('chatbot_error_name_require'))
      return
    }
    setSubmitting(true)
    let data = mode === 'edit' ? { messageId: message._id } : {}
    data = {
      ...data,
      createdTo: message.createdTo,
      name: message.name,
      message: message.message,
      groupMessagesId: groupsInfo._id
    }
    smartChat.addMessage(data).then(result => {
      setSubmitting(false)
      getMessageGroup({ message: result.data, mode: mode })
      setMode('list')
    }).catch(() => {
      setMessageError(I18n.t('generic_error'))
      setSubmitting(false)
    })
  }

  const deleteMessage = () => {
    setSubmitting(true)
    const data = {
      messageId: message._id,
      groupMessagesId: groupsInfo._id
    }
    smartChat.deleteMessage(data).then(result => {
      setSubmitting(false)
      getMessageGroup({ message: message, mode: 'remove' })
      setMode('list')
    }).catch(() => {
      setSubmitting(false)
    })
  }

  return (
    <div className='message-container' key={`$message-{message._id}`}>
      <div className='message-header'>
        {mode === 'list' ? (
          <h1>{message.name}</h1>
        ) : (
          <input type='text' value={message.name} placeholder={I18n.t('dashboard_message-name')} onChange={event => setMessage({ ...message, name: event.target.value })}/>
        )}
        <div className='message-icons'>
          {mode === 'list' ? (
            <>
              <i className='fa fa-pencil pointer' onClick={toogleEdit} />
              <i className='fa fa-trash pointer' onClick={toggleDelete}/>
              <i className='fa fa-bars drag-item' {...props.handleDragAndDrop} />
            </>
          ) : (
            <img className='pointer' src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='close' onClick={close} />
          )}
        </div>
      </div>
      {mode !== 'list' &&
        <>
          <div className='message-body'>
            <TextEditor2
              id={`message-input-${message._id}`}
              cols={5}
              rows={7}
              value={mode === 'edit' ? (message.message.contentHtml || message.message.content || '') : ''}
              company={company}
              attachments={message.message.attachments}
              buttons={message.message.buttons}
              removeEmojisAndAccentsValue={message.message.removeEmojisAndAccents}
              limit={0}
              options={['preview', 'buttons', 'emojis', 'attachments']}
              onChange={(e) => {
                const preview = {
                  content: e.value,
                  contentHtml: e.valueHtml,
                  buttons: e.buttons || [],
                  attachments: e.attachments || [],
                  removeEmojisAndAccents: e.removeEmojisAndAccents
                }
                setMessage({ ...message, message: preview })  // --> No se debería actualizar el mismo estado que recibe, genera bucle si alguno de los datos cambia.
                setTextPreview({ ...preview })
              }}
              dropZoneFilesHeight={230.84}
              currentChannelPreview={currentChannelPreview}
              onPreviewMsg={togglePhonePreviewModal}
              cleanSms
              isTemplateValue
              minHeight={170}
              maxHeight={null}
            />
          </div>
          {messageError && <small className='error-message'>{messageError}</small>}
          <div className='message-footer'>
            <Button
              secondary
              onClick={saveMessage}
              value={I18n.t('dashboard_save')}
              isSubmitting={submitting}
            />
            <Button
              onClick={close}
              value={I18n.t('dashboard_cancel')}
            />
          </div>
        </>
      }
      <ModalWrapper
        isOpen={isOpenPhonePreviewModal}
        toggle={togglePhonePreviewModal}
        header={I18n.t('dashboard_preview')}
        eventBtnTxt={I18n.t('dashboard_close')}
        eventBtn={togglePhonePreviewModal}
        contentClassName='modal-content-phone-preview'
        body={
          <div className='modal-content'>
            <PhoneViewer
              textPreview={textPreview}
              setCurrentChannelPreview={setCurrentChannelPreview}
            />
          </div>
        }
      />
      <ModalDelete
        isOpen={isOpenDelete}
        toggle={toggleDelete}
        header={lang('dashboard_delete-message')}
        text1={lang('dashboard_delete-message-confirm')}
        text2={lang('dashboard_process-cannot-reversed')}
        event={deleteMessage}
        isSubmitting={submitting}
      />
    </div>
  )
}

export default Message
